































































import { Component, Vue } from 'vue-property-decorator';
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper';
import 'hooper/dist/hooper.css';
import { IInfoArticleLink } from '~/store/cms_content/types';
import sanityService from '~/services/sanity.service';

@Component({ components: { Hooper, Slide, HooperNavigation } })
export default class ArticleListCarousel extends Vue {
  articleList: IInfoArticleLink[] = [];
  interactionStartEvent: any = null;
  eventWasClick = false;

  settings = {
    itemsToShow: 2,
    wheelControl: false,
    trimWhiteSpace: true,
    transition: 300,
    mouseDrag: true,
    touchDrag: true,
    breakpoints: {
      600: {
        itemsToShow: 3,
        itemsToSlide: 1.5,
      },
      1450: {
        itemsToShow: 4,
        itemsToSlide: 2,
      },
    },
  };

  created() {
    this.fetchLearnMoreArticles();
  }

  async fetchLearnMoreArticles() {
    let articleLinkList = await sanityService.getInfoArticleList(
      this.$i18n?.locale,
    );

    if (articleLinkList?.articleLinks) {
      const filteredLinks = articleLinkList.articleLinks.filter(link => {
        const startDate = link.startDate;
        const endDate = link.endDate;
        let meetsStartDateCriteria = true;
        let meetsEndDateCriteria = true;
        const now = new Date();

        if (startDate) {
          const startDateTime = new Date(startDate);
          meetsStartDateCriteria = startDateTime < now;
        }

        if (endDate) {
          const endDateTime = new Date(endDate);
          meetsStartDateCriteria = endDateTime > now;
        }

        return link.enabled && meetsStartDateCriteria && meetsEndDateCriteria;
      });

      this.articleList = filteredLinks;
    }
  }

  preventClickOnDrag(e: any, route: string) {
    if (!this.eventWasClick) {
      e.preventDefault();
    } else if (route) {
      this.$router.push(route);
    }
  }

  onInteractionStart(e: any) {
    this.interactionStartEvent = e;
    this.eventWasClick = false;
  }

  onInteractionStop(e: any) {
    let startX;
    let endX;
    let startY;
    let endY;

    if (e?.type === 'mouseup') {
      startX = this.interactionStartEvent?.clientX;
      endX = e.clientX;
      startY = this.interactionStartEvent?.clientY;
      endY = e.clientY;
    }

    if (e.type === 'touchend') {
      let startTouch = this.interactionStartEvent?.changedTouches;
      let endTouch = e.changedTouches;
      startX = startTouch?.length ? startTouch[0].clientX : null;
      endX = endTouch?.length ? endTouch[0].clientX : null;
      startY = startTouch?.length ? startTouch[0].clientY : null;
      endY = endTouch?.length ? endTouch[0].clientY : null;
    }

    if (
      startX &&
      endX &&
      startY &&
      endY &&
      Math.abs(endX - startX) < 10 &&
      Math.abs(endY - startY) < 10
    ) {
      this.eventWasClick = true;
    }

    this.interactionStartEvent = null;
  }
}
